import Component from './index.vue';
import componentConfig from './package.json';
import baseConfig from '@/config/base-config'

function addBaseConfig(config) {
  config.schema.properties = {
    ...config.schema.properties,
    ...baseConfig.schema.properties
  }
  config.data = {
    ...config.data,
    ...baseConfig.data
  }
  return config
}
const config = addBaseConfig(componentConfig)

// 为组件提供 install 安装方法，供按需引入
Component.install = function(Vue) {
  Vue.component(`${config.name}.${config.version}`, Component);
};

// 默认导出组件
export { Component, config };
